import ResetPasswordStatus from './reset-password-status';

export default ResetPasswordStatus;
